<template>
  <el-dialog
    :title="orgId === null ? '新增單位' : '編輯單位'"
    :visible.sync="innerVisible"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="代號" :label-width="formLabelWidth" prop="code">
        <el-input v-model="form.code" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="名稱" :label-width="formLabelWidth" prop="name">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item
        label="管理帳號"
        :label-width="formLabelWidth"
        prop="adminUserName"
      >
        <el-input
          v-model="form.adminUserName"
          readonly
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="管理名稱"
        :label-width="formLabelWidth"
        prop="adminName"
      >
        <el-input
          v-model="form.adminName"
          readonly
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="管理密碼"
        :label-width="formLabelWidth"
        prop="adminPassword"
      >
        <el-input
          type="password"
          v-model="form.adminPassword"
          :placeholder="orgId === null ? '' : '******'"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="確認密码"
        prop="checkPassword"
        :label-width="formLabelWidth"
      >
        <el-input
          type="password"
          v-model="form.checkPassword"
          :placeholder="orgId === null ? '' : '******'"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item label="備註" :label-width="formLabelWidth">
        <el-input type="textarea" v-model="form.memo"></el-input>
      </el-form-item>

      <el-form-item label="顏色" :label-width="formLabelWidth" prop="color">
        <div style="width:480px;marginBottom:-20px">
          <el-radio-group v-model="form.color">
            <el-radio
              v-for="itemColor in extTagColorList"
              :key="itemColor.name"
              :label="itemColor.name"
            >
              <span :style="{ color: itemColor.textColor }">
                {{ itemColor.txtLabel }}
              </span>
            </el-radio>
          </el-radio-group>
        </div>
      </el-form-item>
    </el-form>
    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit">確 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import tagColorsMixin from "@/components/mixin/tagColors.js";
export default {
  mixins: [tagColorsMixin],
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orgId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    /*const validateName = (rule, value, callback) => {*/
    /*if (this.form.id !== null) {*/
    /*const data = this.$store.getters['organization/getOrganizationById'](this.orgId);*/
    /*if ( data.name === value) {*/
    /*callback();*/
    /*return;*/
    /*}*/
    /*} */
    /*API.organization.search({name: value}).then(res =>{*/
    /*if (res.data.length == 0) {*/
    /*callback();*/
    /*} else {*/
    /*callback(new Error('已存在'));*/
    /*} */
    /*})*/
    /*};*/
    var validatePass = (rule, value, callback) => {
      if (value === "" && this.orgId == null) {
        callback(new Error("請輸入密碼"));
      } else {
        if (this.form.checkPassword !== "") {
          this.$refs.form.validateField("checkPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "" && this.orgId == null) {
        callback(new Error("請再次輸入密碼"));
      } else if (value !== this.form.adminPassword) {
        callback(new Error("兩次輸入密碼不一致!"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        code: [
          { required: true, message: "請輸入代號", trigger: "blur" },
          /*{ validator: validateCode, trigger: 'blur' },*/
        ],
        name: [{ required: true, message: "請輸入名稱", trigger: "blur" }],
        adminPassword: [
          //{ required: true, message: '請輸入管理密碼', trigger: 'blur' },
          { validator: validatePass, trigger: "blur" },
        ],
        checkPassword: [
          //{ required: true, message: '請確認管理密碼', trigger: 'blur' },
          { validator: validatePass2, trigger: "blur" },
        ],
        color: [{ required: true, message: "請輸入顏色", trigger: "blur" }],
      },
      formLabelWidth: "100px",
      form: {
        code: "",
        name: "",
        memo: "",
        adminUserName: "admin",
        adminName: "管理者",
        adminPassword: "",
        checkPassword: "",
        color: "primary",
      },
    };
  },
  created() {
    if (this.innerVisible) {
      if (this.orgId !== null) {
        const data = this.$store.getters["organization/getOrganizationById"](
          this.orgId
        );
        this.form.id = data.id;
        this.form.code = data.code;
        this.form.name = data.name;
        this.form.memo = data.memo;
        this.form.color = data.color;
      }
    }
  },
  methods: {
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.orgId !== null) {
            this.submitUpdate();
          } else {
            this.submitAdd();
          }
        } else {
          return false;
        }
      });
    },
    submitAdd() {
      this.$store.dispatch("organization/add", this.form).then(() => {
        this.innerVisible = false;
        this.$store.dispatch("organization/list", null);
      });
    },
    submitUpdate() {
      this.$store.dispatch("organization/update", this.form).then(() => {
        this.innerVisible = false;
        this.$store.dispatch("organization/list", null);
      });
    },
  },
};
</script>

<style></style>
